import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';

import App from './App.tsx';
import PostHogProvider from './providers/PostHogProvider';

import '@domgen/b2bce-base-ui-design-system-lib/styles.css';
import '@assets/style.css';
import '@assets/fonts.css';
import '@core/i18n';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <PostHogProvider>
      <App />
    </PostHogProvider>
  </StrictMode>
);
